// Author YuJiaBei
// Date 2020-08-07 15:55:23

import * as model from "@/model/em/lifecycle/EmLcAdjustedReportAdrModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmLcAdjustedReportAdr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_LIFECYCLE_URL,
        callbackApi: process.env.VUE_APP_EM_LIFECYCLE_URL + '/emLcAdjustedReportAdr/workflow/complete-feedback',
        processDefinitionKey: "em_lifecycle_adjusted_report",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
